import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Building2, Maximize, ChefHat } from 'lucide-react';
export function BusinessUnits() {
  const units = [{
    icon: <Building2 className="w-10 h-10 text-espresso mb-6" strokeWidth={1.5} data-id="element-11" />,
    title: 'Sector Constructor & Corporativo',
    description: 'Suministro serializado y personalizado para proyectos de vivienda, oficinas y retail.'
  }, {
    icon: <Maximize className="w-10 h-10 text-espresso mb-6" strokeWidth={1.5} data-id="element-12" />,
    title: 'Mobiliario Inteligente & Convertible',
    description: 'Soluciones de ahorro de espacio con tecnología abatible (Camas, escritorios, sistemas dinámicos).'
  }, {
    icon: <ChefHat className="w-10 h-10 text-espresso mb-6" strokeWidth={1.5} data-id="element-13" />,
    title: 'Cocinas & Espacios Premium',
    description: 'Diseño de alto standing con acabados de flujo europeo y herrajes de última generación.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: 'easeOut'
      }
    }
  };
  return <section id="servicios" className="py-24 bg-bone" data-id="element-14">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-bold text-espresso mb-4" data-id="element-17">
            Nuestras Líneas de Negocio
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-18"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-19">
          {units.map((unit, index) => <motion.div key={index} variants={cardVariants} className="bg-white p-10 border border-gray-100 shadow-sm hover:shadow-xl transition-shadow duration-300 relative group overflow-hidden" data-id="element-20">
              <div className="absolute top-0 left-0 w-full h-1 bg-gold transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out" data-id="element-21"></div>

              <div className="relative z-10" data-id="element-22">
                {unit.icon}
                <h3 className="text-xl font-bold text-espresso mb-4 font-serif" data-id="element-23">
                  {unit.title}
                </h3>
                <p className="text-espresso/70 leading-relaxed font-light" data-id="element-24">
                  {unit.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}